import { DocTopic } from '../Constants/Documentation'
import { isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { Branding, getBranding } from '../API/BrandingAPI'
import { DoctopicWindow } from '../Types/Types'
import { APIElements } from '../../../NonReact/constants/ApiConstants'
import { SLASH } from '../Constants/Separators'

/**
 * Opens help portal with topic provided as parameter.
 *
 * @param servletPath Servlet path.
 * @param topic Topic name / identifier.
 */
export const openHelpPortalByTopic = (servletPath: string, topic: string): void => {
    // eslint-disable-next-line
    com.Akixi.HelpPortal.OpenTopic(servletPath, topic)
}

/**
 * Clears the contextual doc topic ID from the window object that is used in old JSP logic that handles F1 key press.
 * When removed the previous logic will work and the modal window doc topic will be not considered.
 */
export const clearModalHelpTopic = (): void => {
    const windowRef: DoctopicWindow = window as Window & typeof globalThis & { modalTopicID: string | undefined }
    windowRef.modalTopicID = undefined
}

/**
 * Sets the contextual doc topic ID to the window object that is used in old JSP logic that handles F1 key press.
 * @param docTopicID
 */
export const setModalHelpTopicID = (docTopicID: string): void => {
    const windowRef: DoctopicWindow = window as Window & typeof globalThis & { modalTopicID: string | undefined }
    windowRef.modalTopicID = docTopicID
}

/**
 * Opens help portal with topic provided as parameter.
 */
export const openHelp = (): void => {
    getBranding().then((branding: Nullable<Branding>): void => {
        const servletPath: string = `/CCS/App${branding?.URLMapping ?? SLASH + APIElements.AKIXI_2019}`
        const windowRef = window as Window &
            typeof globalThis & {
                modalTopicID: Definable<string>
                m_pHelpCapture: {
                    getTopicID: () => DocTopic
                }
            }

        if (isStringNotEmpty(windowRef.modalTopicID)) {
            openHelpPortalByTopic(servletPath, windowRef.modalTopicID)
        } else {
            openHelpPortalByTopic(servletPath, windowRef?.m_pHelpCapture?.getTopicID?.())
        }
    })
}
